import { createSlice } from '@reduxjs/toolkit';

import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';

// Slices

const reportsSlice = createSlice({
  name: 'reports',
  initialState: initialStore.reports,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getTimeframeReportsData: (state, data) => {
      if (!state.isLoadingTimeframe) {
        state.isLoadingTimeframe = true;
      }
    },
    setTimeframeReportsData: (state, { payload }) => {
      state.isLoadingTimeframe = false;
      state.timeframe = payload;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getMomentaryReportsData: (state, data) => {
      if (!state.isLoadingMomentary) {
        state.isLoadingMomentary = true;
      }
    },
    setMomentaryReportsData: (state, { payload }) => {
      const { orders, orderStatusBreakdown } = payload;
      state.isLoadingMomentary = false;
      state.momentary.orders = orders;
      state.momentary.orderStatusBreakdown = orderStatusBreakdown;
    },
    getTimeframeReportsFail: (state) => {
      state.isLoadingTimeframe = false;
    },
    getMomentaryReportsFail: (state) => {
      state.isLoadingMomentary = false;
    }
  }
});

export const {
  getTimeframeReportsData,
  setTimeframeReportsData,
  getMomentaryReportsData,
  setMomentaryReportsData,
  getTimeframeReportsFail,
  getMomentaryReportsFail
} = reportsSlice.actions;

export const { reducer } = reportsSlice;

// Selectors
export const getTimeframeReportsSelector = (state: IState) =>
  state && state.reports.timeframe;

export const getMomentaryReportsSelector = (state: IState) =>
  state && state.reports.momentary;

export const getTimeframeReportsLoadingSelector = (state: IState) =>
  state && state.reports.isLoadingTimeframe;

export const getMomentaryReportsLoadingSelector = (state: IState) =>
  state && state.reports.isLoadingMomentary;
